import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { ModelConstants } from '../model-constants';
import { snowflakeAuthTypes } from '../../interfaces/IAuthenticationType';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.snowflakeLinkedService,
    disabled: isTridentInIframe(),
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, getConnectorV1Name(stringResources.Snowflake_DisplayText)),
        format(stringResources.ModelName_LinkedServicesTemplate, getConnectorV1Name(stringResources.Snowflake_DisplayText))
    ]
})
export class SnowflakeLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly ACCOUNT_NAME: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly DATABASE: IAttribute;
    public static readonly WAREHOUSE: IAttribute;
    public static readonly ROLE: IAttribute;
    public static readonly OAUTH_TOKEN_ENDPOINT: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;
    public static readonly OAUTH_USER_NAME: IAttribute;
    public static readonly OAUTH_PASSWORD: IAttribute;
    public static readonly SCOPE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountName,
        association: 'ACCOUNT_NAME',
        templatable: true
    })
    public accountname: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public user: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string = snowflakeAuthTypes.Basic;

    @Metamodel.attribute({
        display: stringResources.ModelName_OAuthTokenEndpoint,
        association: 'OAUTH_TOKEN_ENDPOINT',
        templatable: true
    })
    public oauthTokenEndpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        association: 'CLIENT_SECRET',
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        templatable: true
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_OAuthUserName,
        association: 'OAUTH_USER_NAME',
        templatable: true
    })
    public oauthUserName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_OAuthPassword,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'OAUTH_PASSWORD',
    })
    public oauthPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScopeLabel,
        association: 'SCOPE',
        templatable: true
    })
    public scope?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.Database,
        association: 'DATABASE',
        templatable: true
    })
    public database: string;

    @Metamodel.attribute({
        display: stringResources.Warehouse_DisplayText,
        association: 'WAREHOUSE',
        templatable: true
    })
    public warehouse: string;

    @Metamodel.attribute({
        display: stringResources.Role,
        association: 'ROLE',
        templatable: true
    })
    public role?: string;

    public enableAKV?: boolean = false;

    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedServiceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public isExistingResourceUsingOAuth: boolean = false;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public editingErrorMessageCustomizer(): string {
        return this.authenticationType === snowflakeAuthTypes.OAuth ? stringResources.Snowflake_Oauth_Disabled_Error : '';
    }
}
